import { ROUTE } from '@/constants/route';

interface ContentModalEligibiliteContratDataType {
  [key: string]: {
    title: string;
    btnLabel: string;
    onClickBtn: (link: string) => void;
  };
}

export const contentModalEligibiliteContratData: ContentModalEligibiliteContratDataType = {
  modalPLAOWN: {
    title: "Le versement n'est pas disponible",
    btnLabel: 'Accéder à mon espace gestionnaire',
    onClickBtn: function (link) {
      globalThis.open(link, '_blank');
    },
  },
  modalRENSPC: {
    title: "Le versement n'est pas disponible",
    btnLabel: "Retourner à l'accueil",
    onClickBtn: function () {
      globalThis.location.replace(ROUTE.DASHBOARD);
    },
  },
  modalPRESPC: {
    title: 'Nous ne trouvons pas de compte de prélèvement',
    btnLabel: 'Accéder à mon espace gestionnaire',
    onClickBtn: function (link) {
      globalThis.open(link, '_blank');
    },
  },
  modalCAPJUR: {
    title: '',
    btnLabel: '',
    onClickBtn: function () {},
  },
  modalGPOUT: {
    title: '',
    btnLabel: '',
    onClickBtn: function () {},
  },
  modalAVNENC: {
    title: '',
    btnLabel: '',
    onClickBtn: function () {},
  },
};
